import ClipTray from "components/app/clip-tray";
import FiltersMenu from "components/app/project/filters-menu";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "types";
import "./content-classification.scss";
import Classifications from "components/app/project/classification";

function ContentClassification() {
  const params: any = useParams();
  const state = useSelector((state: RootState) => state);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [dateFrom, setDateFrom] = useState(moment().subtract(1, "d").set("h", 0).set("m", 0).set("s", 0));
  const [dateTo, setDateTo] = useState(moment());
  const [streamIds, setStreamIds] = useState<number[]>([]);
  const [project, setProject] = useState<any>();
  const filtersRef = useRef<any>();

  useEffect(() => {
    if (state.project) {
      setProject(state.project);
      setStreamIds([7, 8, 9]);
      if (state.project.ProjectTypeId === 5) {
        setStreamIds([7, 8, 9]);
      } else {
        if (state.project.ProjectSubTypeId === 7) {
          setStreamIds([7]);
        } else if (state.project.ProjectSubTypeId === 8) {
          setStreamIds([8]);
        } else if (state.project.ProjectSubTypeId === 9) {
          setStreamIds([10]);
        } else if (state.project.ProjectSubTypeId === 10) {
          setStreamIds([9]);
        } else if (state.project.ProjectSubTypeId === 11) {
          setStreamIds([11]);
        }
      }
    }
  }, [state.project]);

  if (streamIds.length) {
    return (
      <div className="content-classification">
        <div className="top">
          <p className="project-name">{project?.Description}</p>
          <p className="project-type">{project?.ProjectType}</p>
          <span onClick={() => setFiltersOpen(!filtersOpen)} ref={filtersRef}>
            Filter<i className={`fal ${filtersOpen ? "fa-times" : "fa-sliders-h"}`}></i>
          </span>
          <FiltersMenu
            open={filtersOpen}
            setOpen={setFiltersOpen}
            dateFrom={dateFrom}
            setDateFrom={setDateFrom}
            dateTo={dateTo}
            setDateTo={setDateTo}
            streamIds={streamIds}
            setStreamIds={setStreamIds}
            projectTypeId={project?.ProjectTypeId}
            showDatePicker={true}
            buttonRef={filtersRef}
          />
        </div>
        <div className="body">
          <Classifications projectId={params.projectId} dateFrom={dateFrom} dateTo={dateTo} streamIds={streamIds}></Classifications>
        </div>
        <ClipTray />
      </div>
    );
  } else {
    return <></>;
  }
}

export default ContentClassification;
